/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable no-useless-return */
/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router-dom';
import useHalfSpace from 'components/hooks/useHalfSpace';
import useValidateMedia from 'components/hooks/useValidateMedia';
import MainCopyField from 'components/pages/ResourceSetting/Widgets/MainCopyField';
import CtaField from 'components/pages/ResourceSetting/Widgets/CtaField';
import TitleField from 'components/pages/ResourceSetting/Widgets/TitleField';
import DescriptionField from 'components/pages/ResourceSetting/Widgets/DescriptionField';
import MediaField from 'components/pages/ResourceSetting/Widgets/MediaField';
import Ad, { Statuses as AdStatuses } from 'models/business/Ad';
import Asset, { Categories as AssetCategories } from 'models/business/Asset';
import { Categories as PlatformCategories } from 'models/business/Platform';
import ActionButton from 'components/Common/ActionButton';
import HostingUrlField from 'components/pages/ResourceSetting/Widgets/HostingUrlField';
import HideableContainer from 'components/Common/HideableContainer';
import API from 'api';
import Styles from './index.module.css';

export default function MainForm({
  ad,
  onChangeAd,
  // eslint-disable-next-line no-unused-vars
  firstEdit,
  onChangeMedia,
}) {
  const history = useHistory();
  const [isAdSaved, setIsAdSaved] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const { validateImage, validateVideo } = useValidateMedia();
  const { restrictByHalfSpace, halfSpaceLength } = useHalfSpace();
  const [original, setOriginal] = useState({
    ad: new Ad(),
    media: {},
  });
  const [media, _setMedia] = useState({
    prepopulated: null,
    local: null,
  });
  const setMedia = useMemo(() => (m) => {
    _setMedia(m);
    onChangeMedia(m);
  }, [_setMedia]);

  const hasUnsavedChanges = useMemo(() => (
    !original.ad.equals(ad) || original.media !== media
  ), [ad, original, media]);

  const deleteAllMedia = async () => {
    const deletionPromises = [];
    ad.assets.forEach((asset) => {
      if (asset.category === AssetCategories.Media) {
        deletionPromises.push(API.ad.deleteAdMedia(asset.id));
      }
    });

    return Promise.allSettled(deletionPromises);
  };

  const uploadFile = async (file, category) => API.ad.postAdMedia(ad.id, category, file);

  const handleChangeField = (e, field, length) => {
    const newAd = ad.clone();
    const value = length ? restrictByHalfSpace(e.target.value, length, newAd[field]) : e.target.value;
    // if (field === 'mainCopy') {
    //   const rowLimit = 3;
    //   const lines = value.split(/\n/);
    //   if (lines.length > rowLimit) {
    //     value = lines.slice(0, rowLimit).join('\n');
    //   }
    // }
    newAd[field] = value;
    onChangeAd(newAd);
  };

  const saveAd = async () => {
    if (!hasUnsavedChanges) return true;
    setIsAdSaved(false);
    let newOriginalMedia = original.media;
    const clearAdMedia = () => {
      const newMedia = {
        prepopulated: null,
        local: null,
      };
      setMedia(newMedia);
      newOriginalMedia = newMedia;
      const newAd = ad.clone();
      newAd.assets = [];
      onChangeAd(newAd);
    };

    if (ad.platform === PlatformCategories.FacebookCarousel) {
      await deleteAllMedia();
      clearAdMedia();
    }

    if (ad.platform === PlatformCategories.FacebookFeatured) {
      if (!media.prepopulated) {
        await deleteAllMedia();
        if (!media.local) {
          clearAdMedia();
        }
      }
      if (media.local) {
        const result = await uploadFile(media.local, AssetCategories.Media);
        if (!result.error) {
          const newMedia = {
            prepopulated: new Asset(result.resultData),
            local: null,
          };
          setMedia(newMedia);
          newOriginalMedia = newMedia;
          const newAd = ad.clone();
          newAd.injectAssets([new Asset(result.resultData)]);
          onChangeAd(newAd);
        }
      }
    }
    const newAd = ad.clone();
    newAd.status = AdStatuses.Incomplete;
    const result = await API.ad.postUpdateAd(newAd.toJSON());
    if (result.error) {
      alert(result.error.errorMsg);
      setIsAdSaved(true);
      return null;
    }
    setOriginal({
      ad: newAd,
      media: newOriginalMedia,
    });
    setIsAdSaved(true);
    return true;
  };

  const submitAd = async () => {
    saveAd().then((ok) => ok && history.push('/MyAds'));
  };

  useEffect(() => {
    if (!firstLoad || !ad.id) return;
    setFirstLoad(false);
    const originalAd = ad;
    let originalMedia = media;
    const mediaAsset = ad.assets.find((a) => a.category === AssetCategories.Media);
    if (mediaAsset) {
      const newMedia = {
        prepopulated: mediaAsset,
        local: null,
      };
      setMedia(newMedia);
      originalMedia = newMedia;
    }
    setOriginal({
      ad: originalAd,
      media: originalMedia,
    });
  }, [ad]);

  const carouselMode = ad.platform === PlatformCategories.FacebookCarousel;
  const featuredMode = ad.platform === PlatformCategories.FacebookFeatured;

  return (
    <Box
      display="flex"
      flexDirection="column"
      style={{ position: 'relative' }}
    >
      <Box marginBottom={3}>
        <MainCopyField value={ad.mainCopy} onChange={(e) => handleChangeField(e, 'mainCopy')} />
      </Box>
      <HideableContainer hidden={!carouselMode}>
        <Box marginBottom={3}>
          <CtaField value={ad.cta} onChange={(e) => handleChangeField(e, 'cta')} />
        </Box>
      </HideableContainer>
      <HideableContainer hidden={!featuredMode}>
        <Box marginBottom={3}>
          <TitleField value={ad.title} onChange={(e) => handleChangeField(e, 'title', 40)} />
        </Box>
      </HideableContainer>
      <HideableContainer hidden={!featuredMode}>
        <Box marginBottom={3}>
          <DescriptionField value={ad.description} onChange={(e) => handleChangeField(e, 'description', 40)} />
        </Box>
      </HideableContainer>
      <Box marginBottom={3}>
        <HostingUrlField required value={ad.hostingUrl} onChange={(e) => handleChangeField(e, 'hostingUrl')} />
      </Box>
      <HideableContainer hidden={!featuredMode}>
        <Box marginBottom={3}>
          <MediaField
            value={(media.local ?? media.prepopulated ?? {}).name}
            onChange={async (file) => {
              if (file) {
                let valid = await validateImage(file, 1200, 1200);
                if (!valid) valid = await validateVideo(file, 5, 10);
                if (!valid) return;
              }

              setMedia({
                prepopulated: null,
                local: file,
              });
            }}
          />
        </Box>
      </HideableContainer>
      <div className={Styles.formButtons}>
        <ActionButton onClick={saveAd} disabled={!hasUnsavedChanges}>
          儲存進度
        </ActionButton>
        <ActionButton style={{ color: '#FFFFFF' }} onClick={() => history.push('/MyAds')}>
          {firstEdit ? '返回我的廣告' : '取消'}
          {/* 取消 */}
        </ActionButton>
        <ActionButton
          style={{ color: '#FFFFFF' }}
          disabled={(
            !ad.valid
            || (ad.platform === PlatformCategories.FacebookFeatured && !(media?.prepopulated || media?.local))
            || !isAdSaved
          )}
          onClick={submitAd}
        >
          完成
        </ActionButton>
      </div>
    </Box>
  );
}

MainForm.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
  firstEdit: PropTypes.bool,
  onChangeMedia: PropTypes.func,
};

MainForm.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => { },
  firstEdit: false,
  onChangeMedia: () => { },
};
